import React from 'react';
import { Activity, AlertTriangle, CheckCircle, Info, FileText } from 'lucide-react';

const MedicalCard = ({ data }) => {
    if (!data) return null;

    const { title, severity, risk_score, summary, action_plan } = data;

    // Safety: Ensure action_plan is an array. If it's a string, wrap it. If missing, empty array.
    const steps = Array.isArray(action_plan)
        ? action_plan
        : (typeof action_plan === 'string' ? [action_plan] : []);

    // Determine Styling
    let colorClass, iconColor, borderColor, Icon;
    const sev = severity?.toLowerCase() || "";

    if (sev.includes('critical') || sev.includes('high')) {
        colorClass = "bg-red-50 text-red-700";
        borderColor = "border-red-200";
        iconColor = "text-red-600";
        Icon = AlertTriangle;
    } else if (sev.includes('medium')) {
        colorClass = "bg-amber-50 text-amber-700";
        borderColor = "border-amber-200";
        iconColor = "text-amber-600";
        Icon = Activity;
    } else {
        colorClass = "bg-emerald-50 text-emerald-600";
        borderColor = "border-emerald-200";
        iconColor = "text-emerald-600";
        Icon = CheckCircle;
    }

    return (
        <div className={`mt-2 rounded-xl border ${borderColor} overflow-hidden shadow-sm`}>
            {/* Header */}
            <div className={`p-3 flex items-start gap-3 ${colorClass} bg-opacity-50 border-b ${borderColor}`}>
                <Icon className={`w-5 h-5 mt-0.5 ${iconColor}`} />
                <div className="flex-1">
                    <div className="flex justify-between flex-wrap gap-2">
                        <h4 className="font-bold text-sm text-slate-800">{title || "Clinical Assessment"}</h4>
                        <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full border border-current bg-white/50`}>
                            {severity || "INFO"} • Score: {risk_score || "?"}/10
                        </span>
                    </div>
                </div>
            </div>

            {/* Body */}
            <div className="p-3 bg-white">
                <p className="text-sm text-slate-600 mb-3">{summary || "No summary provided."}</p>

                {steps.length > 0 && (
                    <div className="bg-slate-50 rounded-lg p-3 border border-slate-100">
                        <h5 className="text-xs font-bold text-slate-500 uppercase mb-2">Recommended Actions</h5>
                        <ul className="space-y-1">
                            {steps.map((step, i) => (
                                <li key={i} className="text-xs text-slate-700 flex items-start gap-2">
                                    <span className="text-slate-400 mt-0.5">•</span>
                                    <span>{step}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Actions */}
                <div className="mt-3 flex justify-end">
                    <button className="text-xs flex items-center gap-1 text-slate-500 hover:text-blue-600 transition-colors">
                        <FileText size={14} /> Add to Notes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MedicalCard;
